// Auto-generated by @telekom-ods/react-ui-kit postinstall.
//
// ─── HOW TO DISABLE TELEMETRY ───────────────────────────────────────────────
// Telemetry is ON by default in non-production builds. Three equivalent ways
// to opt out, easiest first:
//
//   1) Flip `disableTelemetry` to true in the config block below.
//   2) Set `window._DISABLE_TELEMETRY_ = true` before any ODS component mounts.
//   3) Set the env var `DISABLE_TELEMETRY=true` at build time.
//
// Production builds (`process.env.NODE_ENV === "production"`) never send
// telemetry regardless of this file.
//
// Content Security Policy: if your app sets CSP, you must allow the ingest host
// in `connect-src` (or opt out above). The SDK does not modify CSP for you.
//
// Import this file once in your app entry (e.g. src/main.tsx, app/layout.tsx).
// ────────────────────────────────────────────────────────────────────────────

window.__ODS_TELEMETRY__ = {
  projectName: 'piaas-ui',
  projectPath: 'piaas/piaas-ui',
  includePath: true,
  disableTelemetry: false, // <-- flip to true to opt out
};
window.__ODS_TELEMETRY_ENDPOINT__ = 'https://ods-telemetry-server.dev.oa.yo-digital.com/telemetry';
window.__ODS_TELEMETRY_API_KEY__ =
  'pk_2fa5bb985cb82193e5291d6b838da57bc48e81e1ae3edeb18d08af202f60b586';
